import { createSlice } from "@reduxjs/toolkit";

export const scrollSlice = createSlice({
  name: "scroll",
  initialState: {
    type: "",
    openServiceDescriptionDialog: null,
  },
  reducers: {
    setType: (state, action) => {
      state.type = action.payload;
    },

    setOpenServiceDescriptionDialog: (state, action) => {
      state.openServiceDescriptionDialog = action.payload;
    },

    resetScroll: (state) => {
      state.type = "";
      state.openServiceDescriptionDialog = null;
    },
  },
});

export const { setType, setOpenServiceDescriptionDialog, resetScroll } =
  scrollSlice.actions;

export const selectScroll = (state) => state.scroll;

export default scrollSlice.reducer;
